import * as React from "react"
import { Button } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { productPageImageDetailsHideMasterImages } from "../../@signals"


export default function ShowHideMasterImages() {

	const handleClick = () => productPageImageDetailsHideMasterImages.value = !productPageImageDetailsHideMasterImages.value

	const buttonProps = {
		onClick: handleClick,
		sx: {
			backgroundColor: 'white',
			color: 'primary.main',
			fontSize: '0.87rem', 
			border: '1px solid lightgray',
			py: 1,
			"&:hover": { 
				backgroundColor: 'white',
				boxShadow: 'none',
				cursor: 'pointer'
			}
		}
	}

	return <Button {...buttonProps}>
		<IconSeeker 
			iconWeight='regular'
			icon={productPageImageDetailsHideMasterImages.value ? 'square' : 'square-xmark'}
			sx={{ mr: 1, fontSize: '1.5rem' }} 
		/>
		Show compared official images
	</Button>
}